import { render, staticRenderFns } from "./CarbonEmissions.vue?vue&type=template&id=ae040a72&"
import script from "./CarbonEmissions.vue?vue&type=script&lang=js&"
export * from "./CarbonEmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports